import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { history } from 'utils/Global';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import configureStore from './redux/configureStore';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const appContainer = document.getElementById('root');
const appRoot = ReactDOM.createRoot(appContainer);

const store = configureStore;
if (appContainer.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    appContainer,
    <Provider store={store}>
      <Router basename={baseUrl} history={history}>
        <App />
      </Router>
    </Provider>,
  );
} else {
  appRoot.render(
    <Provider store={store}>
      <Router basename={baseUrl} history={history}>
        <App />
      </Router>
    </Provider>,
  );
}

serviceWorkerRegistration.unregister();
